<template>
  <div style="width: 100%;height: 100%;overflow:auto;">

    <div style="height: 500px;display: flex;">
      <div style="width: 49%;padding: 10px;">
        <el-carousel height="380px" style="border: 1px solid black;margin: 30px 30px 10px 30px;">
          <el-carousel-item v-for="item in imageFiles" :key="item">
           <el-image style="width: 100%;height: 100%;" :src="item.url" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="width: 49%;padding-left: 10px;">
        <el-form label-width="120px" label-position="left">
          <el-form-item >
            <h1>{{parentData.product_name}}</h1>
          </el-form-item>
          <el-form-item label="价格">
            <div style="color: red;font-weight: bold"><span style="font-size: 18px;">￥</span> <span style="font-size: 30px">
              {{parentData.price}}</span></div>

          </el-form-item>
          <el-form-item label="软件编号">
            {{parentData.product_no}}
          </el-form-item>
          <el-form-item label="国家">
            {{parentData.country}}
          </el-form-item>
          <el-form-item label="开发者">
            {{parentData.developer}}
          </el-form-item>
          <el-form-item label="发布日期">
            {{parentData.release_date}}
          </el-form-item>
          <el-form-item label="授权方式">
            <div style="width: 100%;display: flex;color: #108ffe">
<!--              <div style="width: 15%;text-align: center;border: 1px solid #108ffe;border-radius: 5px;margin-right: 5px">-->
              <div class="showDetailFontWidth" :style="{width: (parentData.authorization_type.length * 18 + 20) + 'px'}">
                {{parentData.authorization_type}}</div>
<!--              <div style="width: 15%;text-align: center;border: 1px solid #108ffe;border-radius: 5px;margin-right: 5px">租赁授权</div>-->
<!--              <div style="width: 15%;text-align: center;border: 1px solid #108ffe;border-radius: 5px;margin-right: 5px">场地授权</div>-->

            </div>

          </el-form-item>
          <el-form-item label="部署方式">
            <div style="width: 100%;display: flex;color: #108ffe">
              <div class="showDetailFontWidth" :style="{width: (parentData.deployment_type.length * 18 + 20) + 'px'}">
                {{ parentData.deployment_type }}</div>
<!--              <div style="width: 15%;text-align: center;border: 1px solid #108ffe;border-radius: 5px;margin-right: 5px">网络部署</div>-->

            </div>

          </el-form-item>
          <el-form-item label="支持平台">
            <div style="width: 100%;display: flex;color: #108ffe">
              <div class="showDetailFontWidth" :style="{width: (parentData.support_platform.length * 14 + 20) + 'px'}">
                {{parentData.support_platform}}
              </div>

            </div>

          </el-form-item>
          <el-form-item label="版本号">
            <div style="width: 100%;display: flex;color: #108ffe">
              <div class="showDetailFontWidth" :style="{width: (parentData.version.length * 14 + 20) + 'px'}">
                {{parentData.version}}
              </div>
<!--              <div style="width: 15%;text-align: center;border: 1px solid #108ffe;border-radius: 5px;margin-right: 5px">V2.1.0</div>-->

            </div>

          </el-form-item>
          <el-form-item >
            <el-button type="primary" style="margin-left: 70%;width: 100px" >下载</el-button>
          </el-form-item>

        </el-form>

      </div>
    </div>

    <div style="margin: 10px 20px 10px 30px">
      <h2>软件版本介绍</h2>
    </div>

    <div style="margin: 10px 20px 10px 30px;">
      {{parentData.version_description}}
    </div>

    <el-tabs type="border-card" style="margin: 20px 20px 100px 30px;" >
      <el-tab-pane label="软件详情">
<!--        <div style="width: 100%;display: flex;justify-content: center">-->
<!--        <el-carousel  height="380px" style="width: 70%;border: 1px solid black;margin: 30px 30px 10px 30px;">-->
<!--          <el-carousel-item v-for="item in 4" :key="item">-->
<!--            <h3 class="small justify-center" text="2xl">{{ item }}</h3>-->
<!--          </el-carousel-item>-->
<!--        </el-carousel>-->
<!--        </div>-->

<!--        <div style="color: #108ffe;font-size: 18px">软件功能介绍</div>-->

<!--        <div style="margin-top: 10px">-->
<!--          <div style="font-weight: bold;font-size: 16px">标题</div>-->
<!--          <div>内容</div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in softwareDetailImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>
        </div>

      </el-tab-pane>
      <el-tab-pane label="历史版本">
<!--        <div style="margin-top: 20px">-->
<!--          <div style="font-weight: bold;font-size: 16px">版本名称</div>-->
<!--          <div>内容</div>-->
<!--        </div>-->
<!--        <div style="margin-top: 20px">-->
<!--          <div style="font-weight: bold;font-size: 16px">版本名称</div>-->
<!--          <div>内容</div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in historyImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>

        </div>
      </el-tab-pane>
      <el-tab-pane label="功能模块">
<!--        <div style="margin-top: 20px">-->
<!--          <div style="font-weight: bold;font-size: 16px">模块名称</div>-->
<!--          <div>内容</div>-->
<!--        </div>-->
<!--        <div style="margin-top: 20px">-->
<!--          <div style="font-weight: bold;font-size: 16px">模块名称</div>-->
<!--          <div>内容</div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in functionImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="价格列表">
<!--        <div style="margin-left: 5%;width: 100%;height: 40px;display: flex;text-align: center;line-height: 40px;color: white">-->
<!--          <div style="width: 30%;background-color: #57B3FC;border: 1px solid #c9c3c3">版本名称</div>-->
<!--          <div style="width: 30%;background-color: #57B3FC;border: 1px solid #c9c3c3">功能配置</div>-->
<!--          <div style="width: 30%;background-color: #57B3FC;border: 1px solid #c9c3c3">价格</div>-->
<!--        </div>-->

<!--        <div style="margin-left: 5%;width: 100%;height: 40px;display: flex;text-align: center;line-height: 40px;">-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">名称</div>-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">功能配置</div>-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">￥100</div>-->
<!--        </div>-->

<!--        <div style="margin-left: 5%;width: 100%;height: 40px;display: flex;text-align: center;line-height: 40px;">-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">名称</div>-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">功能配置</div>-->
<!--          <div style="width: 30%;border: 1px solid #c9c3c3">￥100</div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in priceImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="相关产品">
<!--        <div v-loading="loading" style="display: flex;flex-wrap: wrap;">-->
<!--          <div style="width: 30%;height: 450px;padding: 50px;">-->
<!--            <div style="width:50%;height: 50%;margin-left: 25%;margin-top: 20px">-->
<!--              <el-image style="width: 100%;height: 100%;"></el-image>-->
<!--            </div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;font-weight: bold;font-size: 20px;">BitDock</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px">功能强大的矢量图形工具</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;color: red;font-size: 20px">￥239.00</div>-->
<!--          </div>-->

<!--          <div style="width: 30%;height: 450px;padding: 50px;">-->
<!--            <div style="width:50%;height: 50%;margin-left: 25%;margin-top: 20px">-->
<!--              <el-image style="width: 100%;height: 100%;"></el-image>-->
<!--            </div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;font-weight: bold;font-size: 20px;">BitDock</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px">功能强大的矢量图形工具</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;color: red;font-size: 20px">￥239.00</div>-->
<!--          </div>-->

<!--          <div style="width: 30%;height: 450px;padding: 50px;">-->
<!--            <div style="width:50%;height: 50%;margin-left: 25%;margin-top: 20px">-->
<!--              <el-image style="width: 100%;height: 100%;"></el-image>-->
<!--            </div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;font-weight: bold;font-size: 20px;">BitDock</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px">功能强大的矢量图形工具</div>-->
<!--            <div style="display: flex;justify-content: center;align-items: center;height: auto;margin-top:10px;color: red;font-size: 20px">￥239.00</div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in aboutProductImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="业务联络">
<!--        <div style="margin-left: 10px;margin-top:10px;display: flex">-->
<!--          <div style="width: 120px;text-align: right;font-weight: bold">客服邮箱：</div>-->
<!--          <div style="margin-left: 10px;">support@example.com</div>-->
<!--        </div>-->
<!--        <div style="margin-left: 10px;margin-top:10px;display: flex">-->
<!--          <div style="width: 120px;text-align: right;font-weight: bold">紧急联系电话：</div>-->
<!--          <div style="margin-left: 10px;">400-123-4567</div>-->
<!--        </div>-->
<!--        <div style="margin-left: 10px;margin-top:10px;display: flex">-->
<!--          <div style="width: 120px;text-align: right;font-weight: bold">商务合作：</div>-->
<!--          <div style="margin-left: 10px;">biz@example.com</div>-->
<!--        </div>-->
        <div style="margin: 10px;">
          <div v-for="item in businessImageFiles" style="width: 99%">
            <el-image :src="item.url"  style="width: 100%;"></el-image>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>


  </div>

</template>

<script>
export default {
  name: "ProductDetail",


  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      loading:false,
      imageFiles:[],
      softwareDetailImageFiles:[],
      historyImageFiles:[],
      functionImageFiles:[],
      priceImageFiles:[],
      aboutProductImageFiles:[],
      businessImageFiles:[],


    }
  },
  mounted() {
    this.getItemImageUrl();

  },
  methods: {

    async getImageUrl(ids){
      return await this.$http('toolWarehouseService.getImageFiles',{imageIds:ids});
    },

    async getItemImageUrl(){
      this.imageFiles = await this.getImageUrl(this.parentData.detail_image_ids);
      this.softwareDetailImageFiles = await this.getImageUrl(this.parentData.software_detail_image_ids);
      this.historyImageFiles = await this.getImageUrl(this.parentData.history_image_ids);
      this.functionImageFiles = await this.getImageUrl(this.parentData.function_image_ids);
      this.priceImageFiles = await this.getImageUrl(this.parentData.price_image_ids);
      this.aboutProductImageFiles = await this.getImageUrl(this.parentData.about_product_image_ids);
      this.businessImageFiles = await this.getImageUrl(this.parentData.business_image_ids);
    }
  },

}
</script>

<style scoped>


.showDetailFontWidth {
  text-align: center;
  border: 1px solid #108ffe;
  border-radius: 5px;
  margin-right: 5px
}

.el-form-item {
  margin-bottom: 10px
}

.demonstration {
  color: var(--el-text-color-secondary);
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

</style>